import React from 'react';
import SuspensePage from '@/app/ui/SuspensePage';

const Login = React.lazy(() => import('@/pages/auth/Login'));
const Register = React.lazy(() => import('@/pages/auth/Register'));
const ForgotPassword = React.lazy(() => import('@/pages/auth/ForgotPassword'));
const ResetPassword = React.lazy(() => import('@/pages/auth/ResetPassword'));
const VerifyEmail = React.lazy(() => import('@/pages/auth/VerifyEmail'));
const GoogleCallback = React.lazy(() => import('@/pages/auth/GoogleCallback'));
const SelectRole = React.lazy(() => import('@/pages/auth/SelectRole'));

const authRoutes = [
  {
    path: '/login',
    element: (
      <SuspensePage>
        <Login />
      </SuspensePage>
    ),
  },
  {
    path: '/register',
    element: (
      <SuspensePage>
        <Register />
      </SuspensePage>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <SuspensePage>
        <ForgotPassword />
      </SuspensePage>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <SuspensePage>
        <ResetPassword />
      </SuspensePage>
    ),
  },
  {
    path: '/verify-email',
    element: (
      <SuspensePage>
        <VerifyEmail />
      </SuspensePage>
    ),
  },
  {
    path: '/auth/google/callback',
    element: (
      <SuspensePage>
        <GoogleCallback />
      </SuspensePage>
    ),
  },
  {
    path: '/select-role',
    element: (
      <SuspensePage>
        <SelectRole />
      </SuspensePage>
    ),
  },
];

export default authRoutes;
